import { Injectable } from '@angular/core';
import { CookieService } from './cookie.service'; 
import { SessionStorageService } from "./session-storage.service";
import { SessionStorage } from '../../shared/contants/session-storage';
import { Cookie } from '../../shared/contants/cookie';
import { AppConfigService } from './app-config.service'; 
import { MsalService } from '@azure/msal-angular';
//import { HttpClientService } from './http-client.service';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { IApiResponse } from '../models/api-response.model';
import { throwError } from 'rxjs';  
import { map, catchError } from 'rxjs/operators';  
@Injectable({
  providedIn: 'root'
})  
export class LogoutService {

  appConfig: any;
  AdminLogoutRedirectUri: string;
  tokenUrl  : string;
  constructor(private sessionStorageService: SessionStorageService,
    private appConfigService: AppConfigService,
    private msalAuthService: MsalService,
    private http: HttpClient) {
    this.initializeAppConfig();
  }

  initializeAppConfig(): void {
    this.appConfig = this.appConfigService.get();
  }


  /**
   * Method to logout from browser using msal
   */
  msalLogout() {
    this.sessionStorageService.removeItem(SessionStorage.IdToken); 
    this.msalAuthService.logoutRedirect(); 
  }
  getLogoutUrl() {
    const baseUrl = this.appConfig.session.baseUrl;
    const logout = this.appConfig.session.logout;
    return `${baseUrl + logout}`;
  }

  logout(): void {    
    this.tokenUrl = this.getLogoutUrl(); 
    this.sessionStorageService.removeItem(SessionStorage.HighestRoleId);
    this.sessionStorageService.removeItem(SessionStorage.IscookiesettingsButton);
    this.sessionStorageService.removeItem(SessionStorage.Language);
    this.sessionStorageService.removeItem(SessionStorage.PreviousOptanonValue); 

     //call backend service and blacklist the bearerv token
    this.http.post<IApiResponse<boolean>>(this.tokenUrl, {}).subscribe({
      next: (res: IApiResponse<boolean>) => {
        this.msalLogout( );
      },
      error: () => {
        this.msalLogout( );
        console.log("Error while logging out");
      }
    });
  }
   
}
